// Mapping our names for icons to font awesome ones
// eslint-disable-next-line import/prefer-default-export
export const FaIconNames = {
  default: 'ban',
  view: 'eye',
  monitor: 'heartbeat',
  manage: 'recycle',
  connect: 'chart-network',
  learn: 'book',
  settings: 'cog',
  list: 'list',
  map: 'map',
  time: 'clock',
  history: 'clock',
  'history-table': 'stream',
  user: 'user-circle',
  'arrow-down': 'chevron-circle-down',
  'arrow-left': 'chevron-circle-left',
  'arrow-right': 'chevron-circle-right',
  'arrow-up': 'chevron-circle-up',
  'bold-arrow-down': 'angle-down',
  'bold-arrow-left': 'angle-left',
  'bold-arrow-right': 'angle-right',
  'bold-arrow-up': 'angle-up',
  'simple-arrow-left': 'caret-left',
  'simple-arrow-right': 'caret-right',
  'simple-arrow-down': 'angle-down',
  'simple-arrow-up': 'angle-up',
  filter: 'filter',
  question: 'question-circle',
  info: 'info-circle',
  analytics: 'analytics',
  forecast: 'cloud',
  'no-entry': 'ban',
  alert: 'bell',
  notification: 'bullhorn',
  action: 'bullhorn',
  status: 'percentage',
  cohort: 'chart-bar',
  kpi: 'chart-bar',
  'bar-chart': 'chart-bar',
  'pie-chart': 'chart-pie',
  'pie-chart-alt': 'chart-pie',
  'time-chart': 'analytics',
  'stacked-bar-chart': 'layer-group',
  timeseries: 'analytics',
  'line-chart': 'chart-line',
  'filled-chart': 'chart-area',
  'cross-in-circle': 'times-circle',
  'tick-in-circle': 'check-circle',
  'check-in-circle': 'check-circle',
  tick: 'check',
  check: 'check',
  'circle-tick': 'check-circle',
  'circle-check': 'check-circle',
  add: 'plus-circle',
  remove: 'minus-circle',
  upload: 'upload',
  code: 'code',
  save: 'save',
  edit: 'edit',
  pencil: 'pencil',
  email: 'envelope',
  'view-alt': 'eye',
  favourite: 'star',
  unlocked: 'lock-open-alt',
  locked: 'lock-alt',
  logout: 'sign-out-alt',
  options: 'ellipsis-h',
  'more-options': 'ellipsis-h',
  percentage: 'percentage',
  refresh: 'sync-alt',
  cross: 'times',
  'circle-cross': 'times-circle',
  'simple-cross': 'times',
  'bold-cross': 'times-circle',
  close: 'times-circle',
  enlarge: 'expand-arrows-alt',
  fullscreen: 'expand',
  'exit-fullscreen': 'compress',
  'zoom-out': 'expand-arrows-alt',
  'map-flat': 'map-marked',
  'world-map': 'globe-europe',
  tag: 'tag',
  metadata: 'tag',
  telemetry: 'waveform-path',
  delete: 'trash-alt',
  trash: 'trash-alt',
  zoom: 'search-plus',
  lifecycle: 'recycle',
  dashboard: 'tachometer-alt',
  brush: 'paint-brush-alt',
  paintbrush: 'paint-brush-alt',
  notes: 'scroll',
  note: 'scroll',
  search: 'search',
  grouping: 'tags',
  metric: 'function',
  function: 'function',
  google: 'google',
  github: 'github',
  microsoft: 'microsoft',
  apart: 'expand-alt',
  together: 'compress-alt',
  'vertical-resize': 'arrows-alt-v',
  calendar: 'calendar-alt',
  money: 'dollar-sign',
  key: 'key',
  organisation: 'users',
  'check-filled': 'check-circle',
  'cross-filled': 'times-circle',
  infinite: 'infinity',
  exclamation: 'exclamation',
  spinner: 'circle-notch',
  slack: 'slack',
  floorplan: 'building',
  'dashboard-nav': 'tachometer-alt',
  'cohort-nav': 'chart-bar',
  'view-nav': 'eye',
  'monitor-nav': 'heartbeat',
  'rule-nav': 'project-diagram',
  'connect-nav': 'chart-network',
  'settings-nav': 'cogs',
  menu: 'bars',
  'reverse-vertical': 'exchange-alt',
  traffic: 'traffic-light',
  console: 'terminal',
  timeline: 'barcode',
  gauge: 'tachometer-fast',
  circle: 'circle',
  sxs: 'balance-scale-right',
  rule: 'project-diagram',
  warning: 'exclamation-triangle',
  chat: 'comments-alt',
  calculated: 'calculator',
  calculator: 'calculator',
  scatter: 'chart-scatter',
  drop: 'arrow-to-bottom',
  download: 'download',
  token: 'terminal',
  copy: 'copy',
  table: 'table',
  draggable: 'align-justify',
  'bar-chart-large': 'bar-chart',
  'pie-chart-large': 'bar-pie',
  title: 'heading',
  device: 'router',
  model: 'database',
  thermometer: 'thermometer-half',
  wind: 'wind',
  link: 'link',
  unlink: 'unlink',
  merge: 'code-merge',
  print: 'print',
  tree: 'folder-tree',
  error: 'exclamation-circle',
  lifering: 'life-ring',
  percent: 'percent',
  label: 'tag',
  draw: 'drafting-compass',
  microscope: 'microscope',
  incident: 'bug',
  performance: 'analytics',
  priority: 'sort-amount-down',
};
